import { useState } from "react";
import { Car, Clock, Luggage, Plane } from "lucide-react";
import { useBiz } from "@/lib/businessI18n";
import MissionBuilder from "./MissionBuilder";

const TYPES = [
  { id: "transfer", icon: Car },
  { id: "airport", icon: Plane },
  { id: "hourly", icon: Clock },
  { id: "luggage", icon: Luggage },
];

export default function MissionHub({ org, prefill, onDone }) {
  const { t } = useBiz();
  const [selected, setSelected] = useState(prefill?.duplicate?.type || null);
  const [trainMode, setTrainMode] = useState(false);
  const initial = prefill?.duplicate || (prefill?.guest ? { guests: [prefill.guest] } : null);

  if (selected) {
    return (
      <MissionBuilder org={org} type={selected} initial={initial}
        trainMode={trainMode} setTrainMode={selected === "airport" ? setTrainMode : null}
        onBack={() => { setSelected(null); setTrainMode(false); }} onDone={onDone} />
    );
  }

  return (
    <div data-testid="mission-hub" className="mx-auto max-w-4xl">
      <h1 className="text-2xl font-bold tracking-tight text-ink sm:text-3xl" data-testid="hub-title">{t("hub.title")}</h1>
      <p className="mt-1 text-sm text-slate">{t("hub.subtitle")}</p>
      <div className="mt-8 grid grid-cols-1 gap-3 sm:grid-cols-2 lg:grid-cols-3">
        {TYPES.map(({ id, icon: Icon }) => (
          <button key={id} type="button" onClick={() => setSelected(id)} data-testid={`hub-type-${id}`}
            className="group flex items-start gap-3.5 rounded-2xl border border-ink/[0.07] bg-white p-5 text-left transition-all hover:border-miles/40 hover:shadow-[0_8px_24px_rgba(36,87,255,0.08)]">
            <span className="flex h-10 w-10 shrink-0 items-center justify-center rounded-xl bg-miles-ice text-miles transition-colors group-hover:bg-miles group-hover:text-white">
              <Icon className="h-4.5 w-4.5 h-[18px] w-[18px]" strokeWidth={1.5} />
            </span>
            <span>
              <span className="block text-sm font-semibold text-ink">{t(`type.${id}`)}</span>
              <span className="mt-0.5 block text-xs leading-relaxed text-slate">{t(`type.${id}_d`)}</span>
            </span>
          </button>
        ))}
      </div>
    </div>
  );
}
